export default {
	primaryHeading: "How {name} operates",
	secondaryHeading: "Working with {name}",
};
